export default __webpack_public_path__ + "static/media/gridprojekt.517d7009.png";